import ResearchCitationBadge from "./ResearchCitationBadge";
import { Box } from "@mui/material";

// Drop-in wrapper for any input field. Renders its children unchanged and
// overlays a small research-citation badge in the top-right corner when one
// or more research items have been cited into the given fieldKey. Renders no
// extra DOM (just a positioned span) when nothing is cited, so layout stays
// identical for the empty case.
const WithResearchBadge = ({
  fieldKey,
  children,
  offsetTop = 0,
  offsetRight = 0,
}) => (
  <Box sx={{ position: "relative" }}>
    <Box
      sx={{
        position: "absolute",
        top: offsetTop,
        right: offsetRight,
        zIndex: 2,
        pointerEvents: "auto",
      }}
    >
      <ResearchCitationBadge fieldKey={fieldKey} />
    </Box>
    {children}
  </Box>
);

export default WithResearchBadge;
